import { eTypeAsnProcess } from '../../../enums/eTypeAsnProcess'
import { SwitchButtonOption } from '../../../interfaces/Generic/State'

export const putAwayConst = () => {
  const options: SwitchButtonOption[] = [
    { label: 'ASN', name: 'asn', value: 'AsnNumber' },
    { label: 'LPN', name: 'lpn', value: 'Lpn' },
    {
      label: 'TN',
      name: 'Tracking Number',
      value: 'TrackingNumber'
    },
    { label: 'OT', name: 'ot', value: 'WorkOrderId' }
  ]

  const optionsView: SwitchButtonOption[] = [
    { label: 'SKU', name: 'sku', value: 'skuId' },
    { label: 'NOMBRE', name: 'nombre', value: 'skuName' }
  ]

  return { options, optionsView }
}

export const OptionsSwitchPutAwayUnknow = () => {
  const options: SwitchButtonOption[] = [
    {
      label: 'Recepción',
      name: 'Recepción',
      value: eTypeAsnProcess.Inbound.toString()
    },
    {
      label: 'Devoluciones',
      name: 'Devoluciones',
      value: eTypeAsnProcess.Return.toString()
    }
  ]

  return { options }
}
